import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// 路由
export const routes = [
  {
    name: "home",
    path: "/",
    redirect: "/user/index",
    component: () => import("@/views/user/index"),
    meta: {
      title: "用户中心",
    },
  },
  {
    name: "auth",
    path: "/auth",
    redirect: "/auth/login",
    component: () => import("@/views/layout/full"),
    children: [
      {
        name: "AuthLogin",
        path: "login",
        component: () => import("@/views/auth/login"),
        meta: {
          title: "登录",
          keepAlive: true, //开启缓存
        },
      },
      {
        name: "AuthRegister",
        path: "register",
        component: () => import("@/views/auth/register"),
        meta: {
          title: "注册",
        },
      },
      {
        name: "AuthForget",
        path: "forget",
        component: () => import("@/views/auth/forget"),
        meta: {
          title: "忘记密码",
        },
      },
    ],
  },
  {
    name: "user",
    path: "/user",
    redirect: "/user/index",
    component: () => import("@/views/layout"),
    children: [
      {
        name: "UserIndex",
        path: "index",
        component: () => import("@/views/user"),
        meta: {
          title: "个人中心",
        },
      },
      {
        name: "UserProfile",
        path: "profile",
        component: () => import("@/views/user/profile"),
        meta: {
          title: "基本信息",
        },
      },
      {
        name: "UserAddress",
        path: "address",
        component: () => import("@/views/user/address"),
        meta: {
          title: "收件地址",
        },
      },
      {
        name: "UserAccount",
        path: "account",
        component: () => import("@/views/user/account"),
        meta: {
          title: "账户安全",
        },
      },
      {
        name: "UserPassword",
        path: "password",
        component: () => import("@/views/user/password"),
        meta: {
          title: "设置密码",
        },
      },
      {
        name: "UserPayPassword",
        path: "pay_password",
        component: () => import("@/views/user/pay_password"),
        meta: {
          title: "设置支付密码",
        },
      },
      {
        name: "UserPhone",
        path: "phone",
        component: () => import("@/views/user/phone"),
        meta: {
          title: "更换手机号",
        },
      },
      {
        name: "UserIntegral",
        path: "integral",
        component: () => import("@/views/user/integral"),
        meta: {
          title: "我的积分",
        },
      },
      {
        name: "UserRecommend",
        path: "recommend",
        component: () => import("@/views/user/recommend"),
        meta: {
          title: "推荐有礼",
        },
      },
      {
        name: "UserFeedback",
        path: "feedback",
        component: () => import("@/views/user/feedback"),
        meta: {
          title: "其他功能",
        },
      },
      {
        name: "UserFaq",
        path: "faq",
        component: () => import("@/views/user/faq"),
        meta: {
          title: "常见问题",
        },
      },

      {
        name: "UserJoin",
        path: "join",
        component: () => import("@/views/user/join"),
        meta: {
          title: "加入我们",
        },
      },
      {
        name: "UserInvoice",
        path: "invoice",
        component: () => import("@/views/user/invoice"),
        meta: {
          title: "发票",
        },
      },
      {
        name: "UserCoupon",
        path: "coupon",
        component: () => import("@/views/user/coupon"),
        meta: {
          title: "优惠券",
        },
      },
      {
        name: "UserOrderIndex",
        path: "order/index",
        component: () => import("@/views/user/order/index"),
        meta: {
          title: "全部订单",
        },
      },
      {
        name: "UserOrderList",
        path: "order/list/:group",
        component: () => import("@/views/user/order/list"),
        meta: {
          title: "订单列表",
        },
      },
      {
        name: "UserOrderDetail",
        path: "order/detail",
        component: () => import("@/views/user/order/detail"),
        meta: {
          title: "订单详情",
        },
      },
    ],
  },
  {
    name: "invoice",
    path: "/invoice",
    redirect: "/invoice/index",
    component: () => import("@/views/layout"),
    children: [
      {
        name: "InvoiceIndex",
        path: "index",
        component: () => import("@/views/invoice/index"),
        meta: {
          title: "我的发票",
        },
      },
      {
        name: "InvoiceIndex",
        path: "detail",
        component: () => import("@/views/invoice/detail"),
        meta: {
          title: "发票详情",
        },
      },
      {
        name: "InvoiceApply",
        path: "apply",
        component: () => import("@/views/invoice/apply"),
        meta: {
          title: "等待开票",
        },
      },
      {
        name: "InvoiceHeader",
        path: "header",
        component: () => import("@/views/invoice/header"),
        meta: {
          title: "开票信息",
        },
      },
    ],
  },
  {
    name: "team",
    path: "/team",
    redirect: "/team/index",
    component: () => import("@/views/layout"),
    children: [
      {
        name: "TeamIndex",
        path: "index",
        component: () => import("@/views/team"),
        meta: {
          title: "团队主页",
        },
      },
      {
        name: "TeamCenter",
        path: "center/:active",
        component: () => import("@/views/team/center"),
        meta: {
          title: "团队中心",
        },
      },
      {
        name: "TeamApply",
        path: "apply",
        component: () => import("@/views/team/apply"),
        meta: {
          title: "团队申请",
        },
      },
      {
        name: "TeamOrder",
        path: "order/list",
        component: () => import("@/views/team/order/list"),
        meta: {
          title: "团队订单",
        },
      },
      {
        name: "TeamOrder",
        path: "order/detail",
        component: () => import("@/views/team/order/detail"),
        meta: {
          title: "团队订单详情",
        },
      },
    ],
  },
  {
    name: "order",
    path: "/order",
    redirect: "/order/add",
    component: () => import("@/views/layout/full"),
    children: [
      {
        name: "OrderProjectAdd",
        path: "add",
        component: () => import("@/views/order/add"),
        meta: {
          title: "创建项目订单",
        },
      },
      {
        name: "OrderProjectTest",
        path: "test",
        component: () => import("@/views/order/test"),
        meta: {
          title: "创建项目订单",
        },
      },
    ],
  },
  {
    name: "store_order",
    path: "/store_order",
    redirect: "/store_order/add",
    component: () => import("@/views/layout/store"),
    children: [
      {
        name: "StoreOrderAdd",
        path: "add",
        component: () => import("@/views/store_order/add"),
        meta: {
          title: "创建商城订单",
        },
      },
      {
        name: "StoreOrderFast",
        path: "fast",
        component: () => import("@/views/store_order/fast"),
        meta: {
          title: "快速订购",
        },
      },
      {
        name: "StoreOrderIntegral",
        path: "integral",
        component: () => import("@/views/store_order/integral"),
        meta: {
          title: "创建积分兑换订单",
        },
      },
      {
        name: "StoreOrderCashier",
        path: "cashier",
        component: () => import("@/views/store_order/cashier"),
        meta: {
          title: "收银台",
        },
      },
    ],
  },
  {
    name: "withdraw",
    path: "/withdraw",
    redirect: "/withdraw/index",
    component: () => import("@/views/layout"),
    children: [
      {
        name: "WithdrawIndex",
        path: "index",
        component: () => import("@/views/withdraw/index"),
        meta: {
          title: "申请提现",
        },
      },
      {
        name: "WithdrawAccount",
        path: "account",
        component: () => import("@/views/withdraw/account"),
        meta: {
          title: "收款账户",
        },
      },
      {
        name: "WithdrawRecord",
        path: "record",
        component: () => import("@/views/withdraw/record"),
        meta: {
          title: "提现记录",
        },
      },
    ],
  },
  {
    name: "recharge",
    path: "/recharge",
    component: () => import("@/views/layout"),
    children: [
      {
        name: "Recharge",
        path: ":type",
        component: () => import("@/views/recharge"),
        meta: {
          title: "充值",
        },
      },
    ],
  },
  {
    name: "repayment",
    path: "/repayment",
    component: () => import("@/views/layout"),
    children: [
      {
        name: "Repayment",
        path: ":type",
        component: () => import("@/views/repayment"),
        meta: {
          title: "还款",
        },
      },
    ],
  },
  {
    name: "balance",
    path: "/balance",
    component: () => import("@/views/layout"),
    children: [
      {
        name: "balance",
        path: ":type",
        component: () => import("@/views/balance"),
        meta: {
          title: "余额明细",
        },
      },
    ],
  },
  {
    name: "credit_deposit",
    path: "/credit_deposit",
    component: () => import("@/views/layout"),
    children: [
      {
        name: "credit_deposit",
        path: ":type",
        component: () => import("@/views/credit_deposit"),
        meta: {
          title: "信用金明细",
        },
      },
    ],
  },
  {
    name: "vip",
    path: "/vip",
    redirect: "/vip/index",
    component: () => import("@/views/layout/full"),
    children: [
      {
        name: "VipIndex",
        path: "index",
        component: () => import("@/views/vip"),
        meta: {
          title: "开通VIP",
        },
      },
    ],
  },
  {
    name: "page",
    path: "/page",
    redirect: "/page/index",
    component: () => import("@/views/layout/full"),
    children: [
      {
        name: "PageIndex",
        path: "index",
        component: () => import("@/views/page"),
        meta: {
          title: "协议",
        },
      },
    ],
  },
  {
    name: "cart",
    path: "/cart",
    redirect: "/cart/index",
    component: () => import("@/views/layout/store"),
    children: [
      {
        name: "CartIndex",
        path: "index",
        component: () => import("@/views/cart"),
        meta: {
          title: "购物车",
        },
      },
    ],
  },
  {
    name: "cashier",
    path: "/cashier",
    redirect: "/cashier/index",
    component: () => import("@/views/layout/full"),
    children: [
      {
        name: "CashierIndex",
        path: "index",
        component: () => import("@/views/cashier"),
        meta: {
          title: "收银台",
        },
      },
    ],
  },
  {
    name: "academic",
    path: "/academic",
    redirect: "/academic/publish",
    component: () => import("@/views/layout/full"),
    children: [
      {
        name: "AcademicPublish",
        path: "publish",
        component: () => import("@/views/academic/publish"),
        meta: {
          title: "发布需求",
        },
      },
    ],
  },
  {
    name: "print",
    path: "/print",
    component: () => import("@/views/layout/print"),
    children: [
      {
        name: "PrintContract",
        path: "contract",
        component: () => import("@/views/print/contract"),
        meta: {
          title: "合同预览",
        },
      },
      {
        name: "PrintList",
        path: "list",
        component: () => import("@/views/print/list"),
        meta: {
          title: "清单预览",
        },
      },
    ],
  },
  {
    path: "*",
    redirect: "/",
  }, //默认跳转
];

// 将路由表装载到router
export default new Router({
  // require service support
  // mode: "history",
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: routes,
});
